{
  "about.blocks": "Модеровані серверы",
  "about.contact": "Контакт:",
  "about.disclaimer": "Mastodon є задарьнов проґрамов из удпертым кодом тай торговов значков Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Причины не ясні",
  "about.domain_blocks.preamble": "Майбульш Mastodon поволят вам позирати контент тай комуніковати из хосновачами из другых федерованых серверув. Туй лиш уняткы учинені про сись конкретный сервер.",
  "about.domain_blocks.silenced.explanation": "Вы майбульш не будете видіти профілі тай контент из сього сервера, кидь не будете го самі глядати авадь пудпишете ся на нього.",
  "about.domain_blocks.silenced.title": "Обмежено",
  "about.domain_blocks.suspended.explanation": "Ниякі податкы из сього сервера не будут уброблені, усокочені ци поміняні, што чинит невозможнов хоть-яку інтеракцію ци зязок из хосновачами из сього сервера.",
  "about.domain_blocks.suspended.title": "Заблоковано",
  "about.not_available": "Ися інформація не была доступна на сюм сервері.",
  "about.powered_by": "Децентралізована медіа основана на {mastodon}",
  "about.rules": "Правила сервера",
  "account.add_or_remove_from_list": "Дати авадь забрати из исписа",
  "account.badges.bot": "Автоматічно",
  "account.badges.group": "Ґрупа",
  "account.block": "Заблоковати @{name}",
  "account.block_domain": "Заблоковати домен {domain}",
  "account.block_short": "Заблоковати",
  "account.blocked": "Заблоковано",
  "account.cancel_follow_request": "Удмінити пудписку",
  "account.copy": "Зкопіровати удкликованя на профіл",
  "account.direct": "Пошептати @{name}",
  "account.disable_notifications": "Бульше не сповіщати ми коли {name} пише",
  "account.edit_profile": "Управити профіл",
  "account.enable_notifications": "Уповістити ня, кой {name} пише",
  "account.endorse": "Указовати на профілови",
  "account.follow": "Пудписати ся",
  "account.follow_back": "Пудписати ся тоже",
  "account.followers": "Пудписникы",
  "account.followers.empty": "У сього хосновача раз ниє пудписникув.",
  "account.following": "Слідуєте",
  "account.follows.empty": "Сись хосновач щи никого не слідує.",
  "account.go_to_profile": "Перейти на профіл",
  "account.hide_reblogs": "Спрятати друленя уд @{name}",
  "account.joined_short": "Датум прикапчованя",
  "account.languages": "Поміняти убрані языкы",
  "account.link_verified_on": "Властность сього удкликованя было звірено {date}",
  "account.locked_info": "Сись профіл є замкнутый. Ґазда акаунта буде ручно провіряти тко го може зафоловити.",
  "account.media": "Медіа",
  "account.mention": "Спомянути @{name}",
  "account.moved_to": "Хосновач {name} указав, ож новый профіл му є:",
  "account.mute": "Стишити {name}",
  "account.mute_notifications_short": "Стишити голошіня",
  "account.mute_short": "Стишити",
  "account.muted": "Стишено",
  "account.no_bio": "Описа ниє.",
  "account.open_original_page": "Удоперти ориґіналну сторунку",
  "account.posts": "Публикації",
  "account.report": "Скарговати ся на {name}",
  "account.requested_follow": "Хосновач {name} просит ся пудписати ся на вас",
  "account.share": "Пошырити профіл хосновача {name}",
  "account.show_reblogs": "Указати друленя уд {name}",
  "account.unblock": "Розблоковати {name}",
  "account.unblock_domain": "Розблоковати домен {domain}",
  "account.unblock_short": "Розблоковати",
  "account.unendorse": "Не указовати на профілови",
  "account.unfollow": "Удписати ся",
  "account.unmute": "Указовати {name}",
  "account.unmute_notifications_short": "Указовати голошіня",
  "account.unmute_short": "Указовати",
  "account_note.placeholder": "Клопкніт обы додати примітку",
  "admin.dashboard.retention.average": "Середньоє",
  "admin.dashboard.retention.cohort": "Місяць прикапчованя",
  "admin.dashboard.retention.cohort_size": "Нові хосновачі",
  "admin.impact_report.instance_accounts": "Профілі из акаунтув, котрі ся удалят",
  "admin.impact_report.instance_followers": "Пудписникы, котрых стратят наші хосновачі",
  "admin.impact_report.instance_follows": "Пудписникы, котрых стратят їхні хосновачі",
  "admin.impact_report.title": "Вплыв цілком",
  "alert.rate_limited.message": "Попробуйте зась по {retry_time, time, medium}.",
  "alert.rate_limited.title": "Частота обмежена",
  "alert.unexpected.message": "Стала ся нечекана хыба.",
  "alert.unexpected.title": "Ийой!",
  "announcement.announcement": "Голошіня",
  "audio.hide": "Зпрятати звук",
  "block_modal.remote_users_caveat": "Попросиме ґазду сервера {domain} честовати вашоє рішеня. Айбо не ґарантуєме повный соглас, бо даякі серверы можут брати блокованя по-инчакому. Публичні дописы годно быти видко незалоґованым хосновачам.",
  "block_modal.show_less": "Указати менше",
  "block_modal.show_more": "Указати бульше",
  "block_modal.they_will_know": "Они видят, ож сут заблоковані.",
  "block_modal.title": "Заблоковати хосновача?",
  "boost_modal.combo": "Можете клынцнути {combo} другый раз обы сесе пропустити",
  "bundle_column_error.copy_stacktrace": "Укопіровати звіт за хыбу",
  "bundle_column_error.error.body": "Не годни сьме указати зажадану сторунку. Годно быти спозад хыбы у нашум сістемі, авадь проблемы зумісности бравзера.",
  "bundle_column_error.error.title": "Ийой!",
  "bundle_column_error.network.body": "Стала ся хыба як сьме пробовали напаровати сторунку. Годно ся йсе было стати спозад слабого споєня вашого інтернета, авадь сервера.",
  "bundle_column_error.network.title": "Хыба споєня",
  "bundle_column_error.retry": "Попробуйте зась",
  "bundle_column_error.return": "Вернути ся на головну",
  "bundle_column_error.routing.body": "Не можеме найти сяку сторунку. Бизувні сьте, ож URL у адресному шорикови є добрый?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Заперти",
  "bundle_modal_error.retry": "Попробовати зась",
  "closed_registrations.other_server_instructions": "Mastodon є децентралізованов платформов, можете си учинити профіл и на другому серверови тай комуніковати из сим.",
  "closed_registrations_modal.description": "Раз не мож учинити профіл на {domain}, айбо не мусите мати профіл ипен на серверови {domain} обы хосновати Mastodon.",
  "closed_registrations_modal.find_another_server": "Найти другый сервер",
  "column.about": "За сайт",
  "column.blocks": "Заблоковані хосновачі",
  "column.bookmarks": "Усокоченоє",
  "column.direct": "Шептаня",
  "column.directory": "Никати профілі",
  "column.domain_blocks": "Заблоковані домены",
  "column.favourites": "Убраноє",
  "column.follow_requests": "Запросы на пудписку",
  "column.lists": "Исписы",
  "column.mutes": "Стишені хосновачі",
  "column.notifications": "Убвіщеня",
  "column.pins": "Закріплені публикації",
  "column_back_button.label": "Назад",
  "column_header.hide_settings": "Спрятати штімованя",
  "column_header.moveLeft_settings": "Посунути колонку до ліва",
  "column_header.moveRight_settings": "Посунути колонку до права",
  "column_header.pin": "Закріпити",
  "column_header.show_settings": "Указати штімованя",
  "column_header.unpin": "Удкріпити",
  "community.column_settings.local_only": "Лем локалноє",
  "community.column_settings.media_only": "Лем медіа",
  "compose.language.change": "Поміняти язык",
  "compose.language.search": "Глядати языкы...",
  "compose.published.body": "Пост опубликованый.",
  "compose.published.open": "Удкрыти",
  "compose.saved.body": "Пост усокоченый.",
  "compose_form.direct_message_warning_learn_more": "Читайте бульше",
  "compose_form.encryption_warning": "Публикації на Mastodon не шіфрувут ся. Не шырьте чутливу інформацію через Mastodon.",
  "compose_form.hashtag_warning": "Сись пост не буде ся появляти у исписови по гештеґови, бо вун не є публичный. Лишек публичні посты буде видко за гештеґом.",
  "compose_form.lock_disclaimer": "Ваш профіл є {locked}. Хоть-тко може ся на вас пудписати, обы видїти ваші ексклузівні посты.",
  "compose_form.lock_disclaimer.lock": "замкнено",
  "compose_form.placeholder": "Што нового?",
  "compose_form.poll.duration": "Трывалость убзвідованя",
  "compose_form.poll.multiple": "Дакулько варіантув",
  "compose_form.poll.option_placeholder": "Варіант {number}",
  "compose_form.poll.switch_to_multiple": "Змінити убзвідованя обы поволити дакулько варіантув",
  "compose_form.poll.switch_to_single": "Змінити убзвідованя обы поволити лишек єден варіант",
  "compose_form.poll.type": "Стіл",
  "compose_form.publish": "Публикація",
  "compose_form.reply": "Удповідь",
  "compose_form.save_changes": "Усокотити",
  "confirmations.logout.confirm": "Уйти гет",
  "confirmations.logout.message": "Бизувні сьте ож хочете уйти?",
  "confirmations.logout.title": "Уйти гет?",
  "confirmations.mute.confirm": "Стишити",
  "copypaste.copy_to_clipboard": "Копіровати у памнять",
  "directory.recently_active": "Недавно актівні",
  "disabled_account_banner.account_settings": "Штімованя акаунта",
  "disabled_account_banner.text": "Ваш акаунт {disabledAccount} раз є неактівный.",
  "dismissable_banner.community_timeline": "Туй сут недавні публикації уд профілув на серверови {domain}."
}
